import React from "react";

const IncidentsSearch = ({ keyword, handleSearchFilterClick }) => {
  const BarStyling = {
    width: "20rem",
    border: '1px solid black',
  };
  return (
    <input
      style={BarStyling}
      key="search"
      value={keyword}
      onChange={(e) => handleSearchFilterClick(e.target.value)}
    />
  );
};

export default IncidentsSearch;



// WEBPACK FOOTER //
// ./src/incidents/incidentsSearch.js